import { useTheme } from '@mui/material';

import { ScreenSizes } from '@interfaces/index';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    fullAvatarImg: {
      height: '100%',
      position: 'absolute',
      top: '50%',
      left: 0,
      transform: 'translateY(-50%)',
      // The render is a square transparent PNG, so its width equals the height
      // of the content card — i.e. it does not shrink with the window width.
      // Below this breakpoint the free zone on the left becomes narrower than
      // the render, so the preview is centered in that zone instead of staying
      // pinned to the left edge and sliding onto the content card.
      [breakpoints.down(ScreenSizes.PcWide)]: {
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
    },
  };
};
